import React, { useState, useEffect } from "react";
import logo from "../img/logo_m.png";
import PlanoForm from "./PlanoForm";
import CorretoraForm from "./CorretoraForm";
import PropostasView from "./PropostasView";
import AnaliseView from "./AnaliseView";
import MedicoView from "./MedicoView";
import AprovadoView from './AprovadoView';
import FinalizadoView from './FinalizadoView';
import RegrasView from "./RegrasView";
import BeneficiarioView from "./BeneficiarioView"
import RelatorioView from "./RelatorioView"



//Formulario para cadastrar corretora
function CorretorasView() {
  const [corretoras, setCorretoras] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [corretoraEdit, setCorretoraEdit] = useState(null); // <--- NOVO

  useEffect(() => {
    fetch("https://gerencial.vionia.com.br/api/corretoras")
      .then(res => res.ok ? res.json() : [])
      .then(data => setCorretoras(data || []))
      .catch(() => setCorretoras([]));
  }, [showForm]);

  // Toggle Ativo da Corretora
  const handleToggleAtivoCorretora = async (cnpj_corretora, atual) => {
    const response = await fetch(
      `https://gerencial.vionia.com.br/api/corretoras/${cnpj_corretora}/ativo`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(!atual), // inverte o status atual
      }
    );
    if (response.ok) {
      setCorretoras(prev =>
        prev.map(c =>
          c.cnpj_corretora === cnpj_corretora
            ? { ...c, ativo: Number(!atual) }
            : c
        )
      );
    }
  };

  // NOVO: abre o formulário para editar
  const handleEditar = (corretora) => {
    setCorretoraEdit(corretora);
    setShowForm(true);
  };

  // NOVO: fecha formulário e limpa edição
  const handleFecharForm = () => {
    setShowForm(false);
    setCorretoraEdit(null);
  };

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Corretoras</h2>
      <button
        onClick={() => { setShowForm(true); setCorretoraEdit(null); }}
        style={{
          marginBottom: 18,
          padding: "8px 22px",
          background: "#00bcd4",
          color: "#fff",
          fontWeight: 600,
          border: 0,
          borderRadius: 8,
          cursor: "pointer",
          fontSize: 16,
        }}
      >
        Criar nova corretora
      </button>
      {showForm && (
        <CorretoraForm
          corretora={corretoraEdit} // <--- aqui!
          onSuccess={handleFecharForm}
          onCancel={handleFecharForm}
        />
      )}

      <table
        style={{
          width: "100%",
          background: "#fff",
          borderRadius: 8,
          boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        }}
      >
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: 8 }}>CNPJ</th>
            <th style={{ textAlign: "left", padding: 8 }}>Nome</th>
            <th style={{ textAlign: "left", padding: 8 }}>CPF do responsável</th>
            <th style={{ textAlign: "left", padding: 8 }}>Responsável</th>
            <th style={{ textAlign: "left", padding: 8 }}>Email</th>
            <th style={{ textAlign: "left", padding: 8 }}>Telefone</th>
            <th style={{ textAlign: "center", padding: 8 }}>Ativo</th>
            <th style={{ textAlign: "center", padding: 8 }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {corretoras.length === 0 ? (
            <tr>
              <td colSpan={8} style={{ padding: 16, textAlign: "center", color: "#888" }}>
                Nenhuma corretora encontrada.
              </td>
            </tr>
          ) : (
            corretoras.map(c => (
              <tr key={c.cnpj_corretora}>
                <td style={{ padding: 8 }}>{c.cnpj_corretora}</td>
                <td style={{ padding: 8 }}>{c.nome_corretora}</td>
                <td style={{ padding: 8 }}>{c.cpf_usuario}</td>
                <td style={{ padding: 8 }}>{c.responsavel}</td>
                <td style={{ padding: 8 }}>{c.email}</td>
                <td style={{ padding: 8 }}>{c.telefone}</td>
                <td style={{ padding: 8, textAlign: "center" }}>
                  <label style={{ display: "inline-block", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={!!c.ativo}
                      onChange={() => handleToggleAtivoCorretora(c.cnpj_corretora, c.ativo)}
                      style={{ display: "none" }}
                    />
                    <span
                      style={{
                        display: "inline-block",
                        width: 40,
                        height: 24,
                        background: c.ativo ? "#00bcd4" : "#ccc",
                        borderRadius: 24,
                        position: "relative",
                        transition: "background 0.2s",
                        verticalAlign: "middle",
                      }}
                      title={c.ativo ? "Ativo" : "Inativo"}
                    >
                      <span
                        style={{
                          display: "block",
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          background: "#fff",
                          position: "absolute",
                          top: 2,
                          left: c.ativo ? 18 : 2,
                          transition: "left 0.2s",
                        }}
                      />
                    </span>
                  </label>
                </td>
                <td style={{ padding: 8, textAlign: "center" }}>
                  <button
                    onClick={() => handleEditar(c)}
                    style={{
                      background: "#00bcd4",
                      color: "#fff",
                      border: 0,
                      borderRadius: 8,
                      padding: "6px 18px",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}




// --- Formulário para adicionar vendedor ---
function VendedorForm({ onSuccess, onCancel }) {
  const cnpj_corretora = localStorage.getItem("cnpj_corretora") || "";
  const nome_corretora = localStorage.getItem("nome_corretora") || "";
  const tipo_usuario = localStorage.getItem("tipo_usuario");
  const nome_usuario = localStorage.getItem("nome_usuario");
  const cpf_usuario = localStorage.getItem("cpf_usuario");

  const [form, setForm] = useState({
    cpf_usuario: "",
    nome_completo: "",
    telefone: "",
    email: "",
    senha: "",
    tipo: "V",
    Ativo: 1,
  });
  const [mensagem, setMensagem] = useState("");

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleAtivoToggle = () => {
    setForm(f => ({ ...f, Ativo: f.Ativo ? 0 : 1 }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setMensagem("");
    if (!form.cpf_usuario || !form.nome_completo || !form.email || !form.senha) {
      setMensagem("Preencha todos os campos obrigatórios.");
      return;
    }
    const payload = { cnpj_corretora, nome_corretora, ...form };
    try {
      const response = await fetch("https://gerencial.vionia.com.br/api/vendedor_add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setMensagem("Vendedor cadastrado com sucesso!");
        setForm({
          cpf_usuario: "",
          nome_completo: "",
          telefone: "",
          email: "",
          senha: "",
          tipo: "V",
          Ativo: 1,
        });
        if (onSuccess) onSuccess();
      } else {
        const data = await response.json();
        setMensagem(data.detail || "Erro ao cadastrar vendedor.");
      }
    } catch {
      setMensagem("Erro de conexão com o servidor.");
    }
  };

  const inputStyle = {
    width: "100%",
    border: "1.5px solid #d3d7e0",
    borderRadius: 12,
    padding: "10px 14px",
    fontSize: 16,
    color: "#555",
    background: "#f8fafd",
    marginBottom: 16,
    outline: "none",
    transition: "border 0.2s",
  };
  const labelStyle = {
    fontWeight: 500,
    fontSize: 15,
    color: "#888",
    marginBottom: 3,
    display: "block",
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "#fff",
        borderRadius: 18,
        padding: 28,
        maxWidth: 430,
        margin: "30px auto",
        boxShadow: "0 6px 32px 0 rgba(44,62,80,.07)",
        fontFamily: "Inter, Arial, sans-serif"
      }}
    >
      <h3 style={{ marginTop: 0, marginBottom: 18, color: "#353535", fontWeight: 700 }}>Novo Vendedor</h3>
      <div>
        <label style={labelStyle}>Nome completo *</label>
        <input
          name="nome_completo"
          value={form.nome_completo}
          onChange={handleChange}
          required
          style={inputStyle}
          placeholder="Ex: Maria Silva"
        />
      </div>
      <div>
        <label style={labelStyle}>CPF *</label>
        <input
          name="cpf_usuario"
          value={form.cpf_usuario}
          onChange={handleChange}
          required
          maxLength={14}
          style={inputStyle}
          placeholder="Apenas números"
        />
      </div>
      <div>
        <label style={labelStyle}>Telefone</label>
        <input
          name="telefone"
          value={form.telefone}
          onChange={handleChange}
          maxLength={15}
          style={inputStyle}
          placeholder="(11) 98888-7766"
        />
      </div>
      <div>
        <label style={labelStyle}>Email *</label>
        <input
          name="email"
          value={form.email}
          onChange={handleChange}
          type="email"
          required
          style={inputStyle}
          placeholder="usuario@email.com"
        />
      </div>
      <div>
        <label style={labelStyle}>Senha *</label>
        <input
          name="senha"
          value={form.senha}
          onChange={handleChange}
          type="password"
          required
          style={inputStyle}
          placeholder="Senha para login"
        />
      </div>
      <div>
        <label style={labelStyle}>Tipo *</label>
        <select
          name="tipo"
          value={form.tipo}
          onChange={handleChange}
          style={{ ...inputStyle, paddingRight: 28 }}
        >
          <option value="V">Vendedor</option>
          
        </select>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ ...labelStyle, marginRight: 12, display: "inline-block" }}>
          Ativo
        </label>
        <input
          type="checkbox"
          checked={!!form.Ativo}
          onChange={handleAtivoToggle}
          style={{
            marginLeft: 8,
            width: 22, height: 22,
            borderRadius: 8, accentColor: "#00bcd4", verticalAlign: "middle"
          }}
        />
      </div>
      <div style={{ margin: "12px 0", color: "#98a1b2", fontSize: 13 }}>
        <b>CNPJ Corretora:</b> {cnpj_corretora}<br />
        <b>Nome Corretora:</b> {nome_corretora}
      </div>
      {mensagem && (
        <div style={{ color: mensagem.includes("sucesso") ? "#13b66b" : "#e04d4d", marginBottom: 14 }}>
          {mensagem}
        </div>
      )}
      <div style={{ display: "flex", gap: 16 }}>
        <button type="submit" style={{
          flex: 1,
          background: "#00bcd4",
          color: "#fff",
          border: 0,
          borderRadius: 13,
          padding: 13,
          fontWeight: 700,
          fontSize: 16,
          boxShadow: "0 2px 8px 0 rgba(0,188,212,0.07)",
          cursor: "pointer",
          transition: "background 0.2s"
        }}>
          Salvar
        </button>
        <button type="button" onClick={onCancel} style={{
          flex: 1,
          background: "#f4f5fa",
          color: "#888",
          border: 0,
          borderRadius: 13,
          padding: 13,
          fontWeight: 600,
          fontSize: 16,
          cursor: "pointer",
        }}>
          Cancelar
        </button>
      </div>
    </form>
  );
}


// --- Formulário Planos---
function PlanosView() {
  const [planos, setPlanos] = useState([]);
  const [planoSelecionado, setPlanoSelecionado] = useState(null);
  const [formNovo, setFormNovo] = useState(false);
  const [loading, setLoading] = useState(true);
  const cnpj_corretora = localStorage.getItem("cnpj_corretora");
  const tipoUsuario = String(localStorage.getItem("tipo_usuario")).toUpperCase();
  const [mostrarInativos, setMostrarInativos] = useState(false);

  useEffect(() => {
    if (!cnpj_corretora) return;
    setLoading(true);
    fetch(`https://gerencial.vionia.com.br/api/planos?cnpj=${cnpj_corretora}`)
      .then(res => {
        if (!res.ok) throw new Error("Erro ao buscar planos");
        return res.json();
      })
      .then(data => {
        console.log("PLANOS VINDOS DO BACKEND:", data); // <-- Coloque aqui!
        setPlanos(data);
      })
      .catch(() => setPlanos([]))
      .finally(() => setLoading(false));
  }, [cnpj_corretora]);

  const handleToggleAtivo = async (planoId, statusAtual) => {
    const novoStatus = statusAtual === "A" ? "I" : "A";
    try {
      const response = await fetch(
        `https://gerencial.vionia.com.br/api/planos/${planoId}/ativo`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ativo: novoStatus }),
        }
      );
      if (response.ok) {
        setPlanos(prev =>
          prev.map(p =>
            p.id === planoId ? { ...p, ATIVO: novoStatus } : p
          )
        );
      } else {
        const err = await response.json();
        alert(err.detail || "Erro backend");
      }
    } catch (err) {
      alert("Erro ao ativar/inativar plano!");
    }
  };

const handleSalvar = (plano) => {
  if (plano.id) {
    // Ajuste: tire o id do body antes do fetch
    const { id, ...dadosParaEditar } = plano;
    console.log("EDITANDO PLANO:", dadosParaEditar);
    fetch(`https://gerencial.vionia.com.br/api/planos/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dadosParaEditar), // não envia o id!
    })
      .then(res => {
        if (!res.ok) throw new Error("Erro ao editar plano");
        setPlanos(planos.map(p => p.id === id ? plano : p));
      })
      .finally(() => {
        setPlanoSelecionado(null);
        setFormNovo(false);
      });
  } else {
    const novo = { ...plano, id: Math.max(0, ...planos.map(p => p.id || 0)) + 1 };
    setPlanos([...planos, novo]);
    setPlanoSelecionado(null);
    setFormNovo(false);
  }
};


  // Veja o que chega dos planos!
  console.log("Planos recebidos:", planos);

  // Filtra e ordena os planos (apenas ativos, a não ser que o filtro esteja ativado)
  const planosFiltrados = [...planos]
    .filter(p => mostrarInativos || p.ATIVO === "A")
    .sort((a, b) => {
      return a.ATIVO === "A" && b.ATIVO !== "A" ? -1
        : a.ATIVO !== "A" && b.ATIVO === "A" ? 1
        : 0;
    });

  return (
    <div style={{ display: "flex", gap: 32 }}>
      {/* Lista de planos */}
      <div style={{
        minWidth: 250, background: "#fff", borderRadius: 13, boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
        padding: 24, height: "fit-content"
      }}>
        <h3 style={{ marginTop: 0 }}>Planos</h3>
        {tipoUsuario === "A" && (
          <button
            onClick={() => { setFormNovo(true); setPlanoSelecionado(null); }}
            style={{
              width: "100%",
              background: "#00bcd4",
              color: "#fff",
              padding: "8px",
              borderRadius: 8,
              marginBottom: 12,
              border: 0,
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            Novo Plano
          </button>
        )}

        {/* FILTRO: Mostrar inativos */}
        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 15, color: "#555", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={mostrarInativos}
              onChange={e => setMostrarInativos(e.target.checked)}
              style={{ marginRight: 6 }}
            />
            Mostrar planos inativos
          </label>
        </div>

        {loading ? (
          <div style={{ color: "#888" }}>Carregando...</div>
        ) : planos.length === 0 ? (
          <div style={{ color: "#888" }}>Nenhum plano cadastrado.</div>
        ) : (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {planosFiltrados.map((p) => (
              <li
                key={p.id}
                style={{ marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}
              >
                <button
                  style={{
                    background: planoSelecionado && planoSelecionado.id === p.id ? "#00bcd4" : "#f3f4f6",
                    color: planoSelecionado && planoSelecionado.id === p.id ? "#fff" : "#222",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 16px",
                    width: "100%",
                    textAlign: "left",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "background 0.2s"
                  }}
                  onClick={() => { setPlanoSelecionado(p); setFormNovo(false); }}
                >
                  <b>{p.produto}</b>
                  <div style={{ fontSize: 13, color: "#7ca" }}>
                    Cod: {p.cod_prod} | ANS: {p.cod_ans}
                  </div>
                </button>
                {/* Switch de ativar/inativar SÓ PARA ADMIN */}
                {tipoUsuario === "A" && (
                  <label style={{ display: "inline-block", cursor: "pointer", marginLeft: 2 }}>
                    <input
                      type="checkbox"
                      checked={p.ATIVO === "A"}
                      onChange={() => handleToggleAtivo(p.id, p.ATIVO)}
                      style={{ display: "none" }}
                    />
                    <span
                      style={{
                        display: "inline-block",
                        width: 36,
                        height: 20,
                        background: p.ATIVO === "A" ? "#00bcd4" : "#ccc",
                        borderRadius: 20,
                        position: "relative",
                        transition: "background 0.2s",
                        verticalAlign: "middle",
                      }}
                      title={p.ATIVO === "A" ? "Ativo" : "Inativo"}
                    >
                      <span
                        style={{
                          display: "block",
                          width: 16,
                          height: 16,
                          borderRadius: "50%",
                          background: "#fff",
                          position: "absolute",
                          top: 2,
                          left: p.ATIVO === "A" ? 18 : 2,
                          transition: "left 0.2s",
                        }}
                      />
                    </span>
                  </label>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
      

      {/* Formulário Plano */}
      <div style={{ flex: 1, minWidth: 350 }}>
        {planoSelecionado && !formNovo && (
          <PlanoForm
            plano={planoSelecionado}
            onSave={handleSalvar}
            onCancel={() => setPlanoSelecionado(null)}
          />
        )}
        {formNovo && (
          <PlanoForm
            plano={null}
            onSave={handleSalvar}
            onCancel={() => setFormNovo(false)}
          />
        )}
        {!planoSelecionado && !formNovo && !loading && (
          <div style={{ color: "#888", marginTop: 48 }}>Selecione um plano ou cadastre um novo.</div>
        )}
      </div>
    </div>
  );
}


// --- Dashboard principal ---
export default function Dashboard() {
  const [vendedores, setVendedores] = useState([]);
  const [menu, setMenu] = useState("vendedores");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [showForm, setShowForm] = useState(false);

  // Puxa TUDO do localStorage só UMA vez aqui:
  const cnpjCorretora = localStorage.getItem("cnpj_corretora") || "";
  const nomeCorretora = localStorage.getItem("nome_corretora") || "";
  const tipoUsuario = localStorage.getItem("tipo_usuario") || "";
  const nome_usuario = localStorage.getItem("nome_usuario") || "";
  const cpf_usuario = localStorage.getItem("cpf_usuario") || "";

  useEffect(() => {
    setNomeUsuario(localStorage.getItem("nome_usuario") || "");
  }, []);

  useEffect(() => {
    if (!cnpjCorretora || !tipoUsuario || !cpf_usuario) {
      setVendedores([]);
      return;
    }
    const url = `https://gerencial.vionia.com.br/api/vendedores?cnpj=${cnpjCorretora}&tipo=${tipoUsuario}&cpf=${cpf_usuario}`;
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Acesso negado");
        return res.json();
      })
      .then((data) => {
        setVendedores(
          data.map((v) => ({
            ...v,
            Ativo: v.Ativo === true || v.Ativo === 1 || v.Ativo === "1" ? true : false,
          }))
        );
      })
      .catch(() => setVendedores([]));
  }, [cnpjCorretora, tipoUsuario, cpf_usuario, showForm]);

 const handleToggleAtivo = async (cpf, atual, cnpjParaToggle) => {
  const novoAtivo = atual ? 0 : 1;
  const response = await fetch(
    `https://gerencial.vionia.com.br/api/vendedores/${cpf}/ativo?cnpj=${cnpjParaToggle}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Boolean(novoAtivo))
    }
  );
  if (response.ok) {
    setVendedores((prev) =>
      prev.map((v) =>
        v.cpf === cpf && v.cnpj_corretora === cnpjParaToggle
          ? { ...v, Ativo: !atual }
          : v
      )
    );
  }
};





  const handleLogoff = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const MenuButton = ({ label, menuKey, menu, setMenu }) => (
  <button
    style={{
      width: "100%",
      padding: "0.75rem",
      border: "none",
      background: menu === menuKey ? "#00bcd4" : "transparent",
      color: menu === menuKey ? "#fff" : "#222",
      textAlign: "left",
      fontWeight: 500,
      borderRadius: 6,
      cursor: "pointer",
      marginBottom: 4
    }}
    onClick={() => setMenu(menuKey)}
  >
    {label}
  </button>
);

  const podeGerenciarAtivo = tipoUsuario === "A" || tipoUsuario === "C";

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f3f4f6" }}>
      {/* Sidebar */}
      <aside
        style={{
          width: 240,
          background: "#fff",
          borderRight: "1px solid #eee",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ margin: "2rem 0" }}>
          <img src={logo} alt="Logo" style={{ width: 120 }} />
        </div>

        {/* Bloco de Dados do Usuário/Corretora */}
        <div style={{
          marginBottom: "1.5rem",
          background: "#f7fafc",
          borderRadius: 10,
          padding: "10px 10px 12px 10px",
          fontSize: 14,
          width: 200,
          boxSizing: "border-box",
          color: "#444"
        }}>
           {tipoUsuario === "C" ? (
              <>
                <div><b>Corretora</b></div>
                <div>Nome: {nomeCorretora}</div>
                <div>CNPJ: {cnpjCorretora}</div>
                <div>Responsável: {nomeUsuario}</div>
                <div>CPF: {cpf_usuario}</div>
              </>
            ) : tipoUsuario === "V" ? (
              <>
                <div><b>Vendedor</b></div>
                <div>Nome: {nomeUsuario}</div>
                <div>CPF: {cpf_usuario}</div>
              </>
            ) : tipoUsuario === "A" ? (
              <>
                <div><b>Administrador</b></div>
                <div>Nome: {nomeUsuario}</div>
                <div>CPF: {cpf_usuario}</div>
                <div>Corretora: {nomeCorretora}</div>
                <div>CNPJ: {cnpjCorretora}</div>
              </>
            ) : null}
        </div>
        {/* Fim Bloco de Dados */}

        <div style={{ marginBottom: "1rem", textAlign: "center" }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 18,
              color: "#333",
              lineHeight: 1.2,
              maxWidth: 180,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={nomeUsuario}
          >
            {nomeUsuario}
          </div>
        </div>
        <button
          onClick={handleLogoff}
          style={{
            marginBottom: "2rem",
            padding: "0.5rem 1.5rem",
            border: "none",
            background: "#f44336",
            color: "#fff",
            borderRadius: 8,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Sair
        </button>
          {/* Seção de Cadastros */}
<div style={{ padding: "0 1rem", marginBottom: 12 }}>
  <div style={{ fontWeight: "bold", fontSize: 14, color: "#666", marginBottom: 6 }}>
    📁 Cadastros
  </div>
  {tipoUsuario === "A" && (
    <MenuButton label="Corretora" menuKey="corretoras" menu={menu} setMenu={setMenu} />
  )}
  <MenuButton label="Vendedores" menuKey="vendedores" menu={menu} setMenu={setMenu} />
  <MenuButton label="Planos" menuKey="planos" menu={menu} setMenu={setMenu} />
  {tipoUsuario === "A" && (
    <MenuButton label="Regras" menuKey="regras" menu={menu} setMenu={setMenu} />
  )}
</div>

<hr style={{ border: "none", borderTop: "1px solid #eee", margin: "12px 0" }} />

{/* Seção de Processos */}
<div style={{ padding: "0 1rem" }}>
  <div style={{ fontWeight: "bold", fontSize: 14, color: "#666", marginBottom: 6 }}>
    📝 Processos
  </div>
  <MenuButton label="Propostas" menuKey="propostas" menu={menu} setMenu={setMenu} />
  {(tipoUsuario === "A" || tipoUsuario === "T") && (
    <MenuButton label="Análise" menuKey="analise" menu={menu} setMenu={setMenu} />
  )}
  {(tipoUsuario === "A" || tipoUsuario === "M") && (
    <MenuButton label="Médico" menuKey="medico" menu={menu} setMenu={setMenu} />
  )}
   {(tipoUsuario === "A" || tipoUsuario === "V") && (
    <MenuButton label="Beneficiario" menuKey="beneficiario" menu={menu} setMenu={setMenu} />
  )}
  {["A", "C", "V"].includes(tipoUsuario) && (
    <>
      <MenuButton label="Aprovado" menuKey="aprovado" menu={menu} setMenu={setMenu} />
      <MenuButton label="Finalizado" menuKey="finalizado" menu={menu} setMenu={setMenu} />
      <MenuButton label="Relatórios" menuKey="relatorio" menu={menu} setMenu={setMenu} />
    </>
  )}
</div>


      </aside>
      {/* Main content */}
      <main style={{ flex: 1, padding: "2rem" }}>
        {menu === "vendedores" && (
          <>
            <h2 style={{ marginBottom: 16 }}>Vendedores vinculados</h2>
            {(tipoUsuario === "A" || tipoUsuario === "C") && (
              <button
                onClick={() => setShowForm(true)}
                style={{
                  marginBottom: 18,
                  padding: "8px 22px",
                  background: "#00bcd4",
                  color: "#fff",
                  fontWeight: 600,
                  border: 0,
                  borderRadius: 8,
                  cursor: "pointer",
                  fontSize: 16,
                }}
              >
                Novo vendedor
              </button>
            )}

            {showForm && (
              <VendedorForm
                onSuccess={() => setShowForm(false)}
                onCancel={() => setShowForm(false)}
              />
            )}

            <table
              style={{
                width: "100%",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
              }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "left", padding: 8 }}>Nome</th>
                  <th style={{ textAlign: "left", padding: 8 }}>CPF</th>
                  <th style={{ textAlign: "left", padding: 8 }}>Email</th>
                  <th style={{ textAlign: "left", padding: 8 }}>Tipo</th>
                  <th style={{ textAlign: "left", padding: 8 }}>CNPJ</th>
                  <th style={{ textAlign: "left", padding: 8 }}>Corretora</th>
                  <th style={{ textAlign: "center", padding: 8 }}>Ativo</th>
                </tr>
              </thead>
              <tbody>
                {vendedores.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{ padding: 16, textAlign: "center", color: "#888" }}
                    >
                      Nenhum vendedor encontrado.
                    </td>
                  </tr>
                ) : (
                  vendedores.map((v) => (
                    <tr key={v.cpf}>
                      <td style={{ padding: 8 }}>{v.nome}</td>
                      <td style={{ padding: 8 }}>{v.cpf}</td>
                      <td style={{ padding: 8 }}>{v.email}</td>
                      <td style={{ padding: 8 }}>{v.tipo_nome}</td>
                      <td style={{ padding: 8 }}>{v.cnpj_corretora}</td>
                      <td style={{ padding: 8 }}>{v.nome_corretora}</td>
                      <td style={{ padding: 8, textAlign: "center" }}>
                        {podeGerenciarAtivo ? (
                          <label style={{ display: "inline-block", cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={!!v.Ativo}
                                onChange={() => {
                                  if (tipoUsuario === "A") {
                                    // Admin: usa o CNPJ da linha (v.cnpj_corretora)
                                    handleToggleAtivo(v.cpf, v.Ativo, v.cnpj_corretora);
                                  } else {
                                    // Corretora/Vendedor: usa o CNPJ do usuário logado
                                    handleToggleAtivo(v.cpf, v.Ativo, cnpjCorretora);
                                  }
                                }}
                                style={{ display: "none" }}
                              />
                            <span
                              style={{
                                display: "inline-block",
                                width: 40,
                                height: 24,
                                background: v.Ativo ? "#00bcd4" : "#ccc",
                                borderRadius: 24,
                                position: "relative",
                                transition: "background 0.2s",
                                verticalAlign: "middle",
                              }}
                            >
                              <span
                                style={{
                                  display: "block",
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  background: "#fff",
                                  position: "absolute",
                                  top: 2,
                                  left: v.Ativo ? 18 : 2,
                                  transition: "left 0.2s",
                                }}
                              />
                            </span>
                          </label>
                        ) : (
                          <span
                            style={{
                              display: "inline-block",
                              width: 40,
                              height: 24,
                              borderRadius: 24,
                              background: v.Ativo ? "#43a047" : "#e53935",
                              border: "1px solid #bbb",
                              position: "relative",
                              boxShadow: v.Ativo ? "0 0 4px #43a04744" : "0 0 4px #e5393544",
                              verticalAlign: "middle",
                            }}
                            title={v.Ativo ? "Ativo" : "Inativo"}
                          >
                            <span
                              style={{
                                display: "block",
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                background: "#fff",
                                position: "absolute",
                                top: 2,
                                left: v.Ativo ? 18 : 2,
                                transition: "left 0.2s",
                              }}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </>
        )}
        {menu === "planos" && <PlanosView />}
        {menu === "corretoras" && <CorretorasView />}
        {menu === "propostas" && <PropostasView />}
        {menu === "analise" && <AnaliseView />}
        {menu === "medico" && <MedicoView />}
        {menu === "aprovado" && <AprovadoView />}
        {menu === "finalizado" && <FinalizadoView />}
        {menu === "regras" && <RegrasView />}
        {menu === "beneficiario" && <BeneficiarioView />}
        {menu === "relatorio" && <RelatorioView />}
        

        


      </main>
    </div>
  );
}
